import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { ControlIcons } from 'owa-control-icons';
import EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import loc from 'owa-localize';
import { cloudLocationsMenuItemText } from '../components/hyperlinkContextMenu.locstring.json';
import { InsertLinkFromFilePickerContext } from '../types/InsertLinkFromFilePickerContext';

export enum AttachButton {
    ONLINE_LOCATION_KEY = 'addOnlineLocationAttachment',
}

const styles = require('../components/HyperlinkContextMenu.scss');
const classNames = require('classnames');

type AttachmentMultiMenuMap<T> = { onlineLocation: T };

/**
 * To add a button, update the AttachButton and AttachmentMultiMenuMap, then update this method.
 */
export function getAttachmentCommandItems(
    filePickerContext: InsertLinkFromFilePickerContext,
    editorViewState: EditorViewState,
    targetWindow: Window
): IContextualMenuItem[] {
    const attachmentMultiMenuInfo: AttachmentMultiMenuMap<{
        actionName: string;
        onClick: () => void;
    }> = {
        onlineLocation: {
            actionName: 'onlineAttach',
            onClick: () => {
                filePickerContext.openFilePickerHandler(
                    filePickerContext.insertLinksHost,
                    editorViewState,
                    targetWindow,
                    filePickerContext.fromAddress
                );
            },
        },
    };

    const defaultButtonTypes: AttachButton[] = [AttachButton.ONLINE_LOCATION_KEY];
    const defaultButtons: IContextualMenuItem[] = [];
    defaultButtonTypes.forEach(defaultButtonType => {
        switch (defaultButtonType) {
            case AttachButton.ONLINE_LOCATION_KEY:
                defaultButtons.push(
                    createAttachmentContextMenuItem(
                        loc(cloudLocationsMenuItemText),
                        AttachButton.ONLINE_LOCATION_KEY,
                        attachmentMultiMenuInfo.onlineLocation.actionName,
                        ControlIcons.Cloud,
                        attachmentMultiMenuInfo.onlineLocation.onClick
                    )
                );
                break;
            default:
                break;
        }
    });

    return defaultButtons;
}

function createAttachmentContextMenuItem(
    menuItemName: string,
    attachButtonType: AttachButton,
    actionName: string,
    iconName: string,
    onClick: () => void
): IContextualMenuItem {
    return {
        key: attachButtonType,
        name: menuItemName,
        iconProps: {
            iconName: iconName,
            styles: { root: classNames(styles.iconRoot, styles.iconPadding) },
        },
        onClick: onClick,
    };
}
